import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { ExchangeRatesFilterParams } from '@/types/exchange-rate'
import { fetchExchangeRates, syncExchangeRates } from '@/lib/api'

export const useExchangeRates = (params: ExchangeRatesFilterParams, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['exchange-rates', params],
    queryFn: () => fetchExchangeRates(params),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: options?.enabled ?? true
  })
}

export const useSyncExchangeRates = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => syncExchangeRates(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exchange-rates'] })
      queryClient.invalidateQueries({ queryKey: ['currencies'] })
    }
  })
}
